import { Component, ElementRef, Input } from "@angular/core";
@Component({
  selector: "ui-snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
})
export class SnackbarComponent {
  constructor(public elementRef: ElementRef<HTMLElement>) {}

  /**
   * Optional, Type = info | success | error.
   */
  @Input() type = "info";
  /**
   * The message for the snackbar.
   */
  @Input() message = "";
  /**
   * Optional, If it is empty or not sent, the title will remain hidden.
   */
  @Input() title = "";
  /**
   * Optional, If it is empty or not sent, the button will remain hidden.
   */
  @Input() buttonMessage = "";
  /**
   * True to show the snackbar.
   */
  @Input() isDisplay = true;

  onClose() {
    const snackbarElement = this.elementRef.nativeElement.firstElementChild;
    snackbarElement && snackbarElement.classList.add("slide-out");
    setTimeout(() => {
      this.isDisplay = false;
    }, 500);
  }
}
